import http, { HttpSuccessOrErrorType, ListResults, WillStopConfig } from '../http';
import { Group } from '../../models';
import { Condition } from '../../models/abstract/condition.entity';
import { AxiosRequestConfig } from 'axios';

export default {

    /**
     * 查找所有Group资源。
     * @param params 参数
     */
    async get_group(config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<Group[] | null>> {
        return await http.get(`/group`, {
            ...config
        })
    },

    /**
     * 按条件查找Group资源。
     * @param params 参数
     */
    async get_group_by_condition(params: Group & Condition, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<{
            dbResults: Group[],
            totalCount: Array<{
                count: number;
            }>
        }[]>> {
        return await http.get(`/group/condition`, {
            params: {
                ...params
            },
            ...config
        })
    },

    /**
     * 获取所有集团授权资源 所有集团 包括集团下的餐厅授权
     * @param string_id 餐厅string_id
     */
    async get_group_all_warrant(params: Group & Condition, config?: WillStopConfig): Promise<HttpSuccessOrErrorType<{
        dbResults: Group[],
        totalCount: Array<{
            count: number;
        }>
    }[]>> {
        return await http.get(`/warrant/condition`, {
            params: {
                ...params
            },
            ...config
        })
    },

    /**
     * 查找Group资源
     * - 不分页
     * @param params 参数
     */
    async get_group_by_condition_V2(params: Group & Condition, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<ListResults<Group>[]>> {
        return await http.get(`/group/conditionV2`, {
            params: {
                ...params
            },
            ...config
        })
    },

    /**
     * 根据Group._id查找单个Group资源。
     * @param params 参数
     */
    async get_group_id_id(_id?: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<Group | null>> {
        return await http.get(`/group/_id/${_id}`, {
            ...config
        })
    },

    /**
     * 修改单个Group资源。
     * @param params 参数
     */
    async patch_group_id_id_info(params: Group, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<any>> {
        const { _id, ...rest } = params;
        return await http.patch(`/group/_id/${_id}/info`, {
            ...rest
        }, config)
    },

    /**
     * 获取nickname列表。
     * @param params 参数
     */
    async get_nick_names(config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<Group | null>> {
        return await http.get(`/group/nickname`, {
            ...config
        })
    },

    /**
     * 根据Group._id删除单个Group资源。
     * @param params 参数
     */
    async delete_group_id_id(_id: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/group/${_id}`, {
            ...config
        })
    },

    /**
     * 根据Group._id删除单个Group资源(硬删除)。
     * @param params 参数
     */
    async delete_group_hard_id(_id: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/group/${_id}/hard`, {
            ...config
        })
    },

    /**
     * 创建单个 section_table 资源
     * @param params 参数
     */
    async post_group(params: Group, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.post('/group', { ...params }, config)
    },

    /**
     * 批量删除
     * @param params 参数
     */
    async delete_group(ids: Array<string>, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete('/group', { data: { _id: ids }, ...config })
    },
    /**
     * 批量硬删除
     * @param params 参数
     */
    async delete_group_hard(ids: Array<string>, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete('/group/hard', { data: { _id: ids }, ...config })
    },

    /**
     * 上传集团logo
     */
    async patch_group_id_logo(_id: string, imageFile: File, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<any>> {
        const formData = new FormData();
        formData.append('', imageFile);
        return (
            await http.patch(`/group/_id/${_id}/logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                ...config
            })
        );
    },

    /**
     * 获取集团图片
     * @param params 参数
     */
    async get_group_id_id_logo(id: string): Promise<HttpSuccessOrErrorType<string | null>> {
        return await http.get(`/group/_id/${id}/logo`)
    },

    /**
     * 修改员工所属集团
     */
    async patch_staff_belonged_gruop(id: string): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch(`/staff/belonged_restaurant`, {
            _id: [id],
        })
    },
}